import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="py-6 border-t mt-auto">
      <div className="container mx-auto px-4 flex justify-between items-center">
        <div className="flex items-center space-x-4">
          <Link to="/" className="text-sm text-gray-600 hover:text-gray-900 inline-flex items-center">
            <Home className="h-4 w-4 mr-1" />
            Home
          </Link>
          <p className="text-sm text-gray-600">© 2025 Spark Quotes. All rights reserved.</p>
        </div>
        <Link to="/verify" className="text-sm text-gray-600 hover:text-gray-900 underline">
          Admin Login
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
